<!-- <form>
  <dx-form [colCount]="12" [(formData)]="form">
    <dxi-item itemType="group" [colSpan]="12" [colCount]="12">

      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('PermissionWorkSystem.title' | translate)
  }" [colSpan]="4" dataField="permissionHeaderWorkSystemId" editorType="dxLookup" [editorOptions]="{dataSource: permission, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
         searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
      </dxi-item>





      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('HolidayWorkSystem.title' | translate)
  }" [colSpan]="4" dataField="holidayHeaderSystemId" editorType="dxLookup" [editorOptions]="{dataSource: holiday, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
      </dxi-item>




      <dxi-item dataField="absenceRuleHeaderSystemId" editorType="dxLookup" [colSpan]="4" [label]="{ visible: false }"
        [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('AbsenceWorkSystem.title' | translate)
  }"></dxi-item>





      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('DelayWorkSystem.title' | translate)
  }" [colSpan]="4" dataField="delayRuleHeaderSystemId" editorType="dxLookup"
        [editorOptions]="{dataSource: DelayRuleList, displayExpr:'nameAr' ,valueExpr :'id' ,searchEnabled: true, showClearButton: true}">
      </dxi-item>






      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('ExtraWorkSystem.title' | translate)
  }" [colSpan]="4" dataField="extraTimeRuleHeaderSystemId" editorType="dxLookup" [editorOptions]="{dataSource: ExtraTimeRuleList, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
        <dxi-validation-rule type="required" message="{{'errors.statusrequired'|translate}}"></dxi-validation-rule>
      </dxi-item>





      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('personnelaffairs.personalsetting' | translate)
  }" dataField="employeeAfairsId" editorType="dxLookup" [colSpan]="4" [editorOptions]="{dataSource: employeeAfairsdropdown, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
        searchMode:'contains',searchExpr: ['nameAr'],
        minSearchLength:'1',showDataBeforeSearch:'true'}">
      </dxi-item>





      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('personnelaffairs.insurancesetting' | translate)
  }" dataField="insuranceId" editorType="dxLookup" [colSpan]="4" [editorOptions]="{dataSource: insurancedropdown, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
      </dxi-item>





      <dxi-item [label]="{ visible: false }" [editorOptions]="{
    dataSource: AbsenceRuleList,
    displayExpr: 'nameAr',
    valueExpr: 'id',
    searchEnabled: true,
    searchMode: 'contains',
    searchExpr: ['nameAr'],
    minSearchLength: 1,
    showDataBeforeSearch: true,
    placeholder: ('personnelaffairs.taxsetting' | translate)
  }" dataField="taxesId" editorType="dxLookup" [colSpan]="4" [editorOptions]="{dataSource: taxesdropdown, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
      </dxi-item>

    </dxi-item>
  </dx-form>
</form> -->



<form>
    <dx-form labelMode="floating" labelLocation="top"   [colCount]="12" [(formData)]="form" >
      <dxi-item itemType="group" [colSpan]="12" [colCount]="12">
        <dxi-item dataField="permissionHeaderWorkSystemId" editorType="dxLookup" [editorOptions]="{dataSource: permission, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
         searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}" [colSpan]="4">
          <dxo-label text="{{'PermissionWorkSystem.title'|translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="holidayHeaderSystemId" editorType="dxLookup" [editorOptions]="{dataSource: holiday, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}" [colSpan]="4">
          <dxo-label text="{{'HolidayWorkSystem.title'|translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="absenceRuleHeaderSystemId" editorType="dxLookup" [editorOptions]="{dataSource:AbsenceRuleList, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
         searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}" [colSpan]="4">
          <dxo-label text="{{'AbsenceWorkSystem.title'|translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="delayRuleHeaderSystemId" editorType="dxLookup"
          [editorOptions]="{dataSource: DelayRuleList, displayExpr:'nameAr' ,valueExpr :'id' ,searchEnabled: true, showClearButton: true}" [colSpan]="4">
          <dxo-label text="{{'DelayWorkSystem.title'|translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="extraTimeRuleHeaderSystemId" editorType="dxLookup" [editorOptions]="{dataSource: ExtraTimeRuleList, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}" [colSpan]="4">
          <dxo-label text="{{'ExtraWorkSystem.title'|translate}}"></dxo-label>
          <dxi-validation-rule type="required" message="{{'errors.statusrequired'|translate}}"></dxi-validation-rule>
        </dxi-item>

        <dxi-item dataField="employeeAfairsId" editorType="dxLookup" [colSpan]="4" [editorOptions]="{dataSource: employeeAfairsdropdown, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
        searchMode:'contains',searchExpr: ['nameAr'],
        minSearchLength:'1',showDataBeforeSearch:'true'}">
          <dxo-label text="{{'personnelaffairs.personalsetting'|translate}}"></dxo-label>
        </dxi-item>
        <dxi-item dataField="insuranceId" editorType="dxLookup" [colSpan]="4" [editorOptions]="{dataSource: insurancedropdown, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
          <dxo-label text="{{'personnelaffairs.insurancesetting'|translate}}"></dxo-label>
        </dxi-item>
        <dxi-item dataField="taxesId" editorType="dxLookup" [colSpan]="4" [editorOptions]="{dataSource: taxesdropdown, displayExpr:'nameAr' ,valueExpr :'id',searchEnabled:'true',
          searchMode:'contains',searchExpr: ['nameAr'],
          minSearchLength:'1',showDataBeforeSearch:'true'}">
          <dxo-label text="{{'personnelaffairs.taxsetting'|translate}}"></dxo-label>
        </dxi-item>
      </dxi-item>
    </dx-form>
  </form>